import { arrayOf } from "prop-types";
import React from "react";
import { withI18n } from "shared/containers/i18n/i18n";
import { handleScrollTop } from "shared/helpers/scrollTo";
import { Card, Button, Label, Icon, Popup } from "semantic-ui-react";
import FormatCurrency from "shared/components/currency/FormatCurrency";
import { FormattedMessage } from "react-intl";
import { I18nShape } from "shared/shapes/i18n.shape";
import { cardGridItemShape } from "shared/shapes/cardGrid.shape";
import { browserHistory } from "../../routes/browserHistory";
import "./cardGrid.scss";

class CardGrid extends React.Component {
  pricePrefix = item => {
    if (item.isMandatoryDisplay) return "";
    if (item.isBasePrice) return "ab";
    if (item.total >= 0) return <Icon name="plus" />;
    return <Icon name="minus" />;
  };

  generateOnClickHandler(item) {
    if (item.isMandatoryDisplay || !(item.url || item.onClick))
      return undefined;
    return () => this.handleClick(item);
  }

  handleClick(item) {
    if (item.url) {
      handleScrollTop();
      browserHistory.push(item.url);
    } else if (item.onClick) {
      item.onClick(item);
    }
  }

  renderPriceTag(item) {
    if (item.isPriceOnRequest) {
      return (
        <Label className="on-request-tag">
          <FormattedMessage
            id="product_price.attributes.on_request.label"
            defaultMessage="product_price.attributes.on_request.label"
          />
        </Label>
      );
    }
    if (!Number.isNaN(item.total)) {
      return (
        <Label className="price-tag">
          {this.pricePrefix(item)}{" "}
          <FormatCurrency amount={Math.abs(item.total)} />
        </Label>
      );
    }

    return "";
  }

  render() {
    const { i18n, items } = this.props;
    return (
      <Card.Group
        data-component="cardGrid"
        itemsPerRow={3}
        stackable
        doubling
        className="tablet-two"
      >
        {items.map(item => {
          const card = (
            <Card
              key={item.key}
              onClick={this.generateOnClickHandler(item)}
              data-model={item.modelType}
              className={`card-key-${item.key}`}
            >
              <Card.Content>
                <Card.Header>{item.title}</Card.Header>
              </Card.Content>
              <div className={item.imageClass}>
                {this.renderPriceTag(item)}
                <div
                  className="canvas"
                  style={{ backgroundImage: `url(${item.imageUrl})` }}
                />
              </div>
              {item.button?.content && (
                <Button
                  // allow the spreading the props are set in navigationButton.js file
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...item.button}
                  content={i18n[item.button.content] || item.button.content}
                />
              )}
            </Card>
          );

          if (item.popup) {
            return (
              <Popup
                trigger={card}
                className="card-popup"
                key={item.key}
                position="bottom center"
              >
                <Popup.Header>{item.popup.header}</Popup.Header>
                <Popup.Content>{item.popup.content}</Popup.Content>
              </Popup>
            );
          }
          return card;
        })}
      </Card.Group>
    );
  }
}

CardGrid.propTypes = {
  i18n: I18nShape.isRequired,
  items: arrayOf(cardGridItemShape).isRequired
};

export default withI18n(CardGrid);
